module.exports = __webpack_public_path__ + "img/Gallery_2_30.7e067408.jpeg";